import * as React from "react"
import { useRef } from "react"
import { Box } from "@mui/material"

import { useTour } from "../@hooks"
import LanguageSelector from "./LanguageSelector"
import TourButton from "./TourButton"

export default function TourActions({ pageKey }) {
    const buttonRef = useRef(null)
    const { handleStartTour, handleClickTourButton } = useTour(pageKey)

    return (
        <Box ref={buttonRef}>
            <TourButton onClick={handleClickTourButton} />
            <LanguageSelector anchorEl={buttonRef.current} onSelect={handleStartTour} />
        </Box>
    )
}
